import { createStore, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";

import rootReducer from "./reducers";

const middleware = [thunk];
const initialState = {};

const store = createStore(rootReducer, initialState, applyMiddleware(...middleware));
store.subscribe(() => {
    if (!localStorage.getItem('_business_panel_token') || localStorage.getItem('_business_panel_token') === null) {
        window.location = "/storelocator/business/login"
    }
})
export default store